"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomRef = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.entries.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _mergeRefs = require("../_utils/mergeRefs");
var _callBoth = require("../_utils/callBoth");
var _excluded = ["children", "domRef"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DomRefInner = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(DomRefInner, _React$Component);
  var _super = _createSuper(DomRefInner);
  function DomRefInner() {
    (0, _classCallCheck2.default)(this, DomRefInner);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(DomRefInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var dom = _reactDom.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
      var domRef = this.props.domRef;
      (0, _mergeRefs.mergeRefs)(domRef)(dom);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var dom = _reactDom.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
      var domRef = this.props.domRef;
      (0, _mergeRefs.mergeRefs)(domRef)(dom);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var domRef = this.props.domRef;
      var demos = null;
      (0, _mergeRefs.mergeRefs)(domRef)(demos);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        domRef = _this$props.domRef,
        props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var childrenElement = children;
      var attachProps = {};

      // 元素类型的，可以把要求渲染的 childrenProps 和原本的 props 合并
      if ( /*#__PURE__*/_react.default.isValidElement(childrenElement)) {
        Object.entries(props).forEach(function (_ref) {
          var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            propName = _ref2[0],
            propValue = _ref2[1];
          if (typeof propValue === 'function') {
            // 子节点之前已经有处理函数，则同时调用
            if (childrenElement.props[propName]) {
              attachProps[propName] = (0, _callBoth.callBoth)(propValue, childrenElement.props[propName]);
            } else {
              attachProps[propName] = propValue;
            }
          } else {
            attachProps[propName] = propValue;
          }
        });
        //   for (const [propName, propValue] of Object.entries(props)) {
        //     if (typeof propValue === "function") {
        //         // 子节点之前已经有处理函数，则同时调用
        //         if (childrenElement.props[propName]) {
        //           attachProps[propName] = callBoth(
        //             propValue,
        //             childrenElement.props[propName]
        //           );
        //         } else {
        //           attachProps[propName] = propValue;
        //         }
        //       } else {
        //         attachProps[propName] = propValue;
        //       }
        //   }
        return /*#__PURE__*/_react.default.cloneElement(childrenElement, attachProps);
      }
      return children;
    }
  }]);
  return DomRefInner;
}(_react.default.Component);
var DomRef = exports.DomRef = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(DomRefInner, (0, _extends2.default)({}, props, {
    domRef: ref
  }));
});